export type OrderFulfillmentStatus =
  | 'Fulfilled'
  | 'Partially Fulfilled'
  | 'Unfulfilled';

type FulfillmentItem = {
  fulfillmentStatus?: string | null;
  fulfilledAt?: Date | string | null;
};

const FULFILLED_ITEM_STATUSES = new Set([
  'FULFILLED',
  'DELIVERED',
  'IN_TRANSIT',
  'OUT_FOR_DELIVERY',
  'ATTEMPTED_DELIVERY',
  'FAILED_ATTEMPT',
  'FAILURE',
]);

const getItemFulfillmentProgress = (item: FulfillmentItem) => {
  const status = item.fulfillmentStatus?.trim().toUpperCase();

  if (status === 'PARTIAL' || status === 'PARTIALLY_FULFILLED') return 0.5;
  if (item.fulfilledAt || (status && FULFILLED_ITEM_STATUSES.has(status))) {
    return 1;
  }
  return 0;
};

export const getOrderFulfillmentStatus = (
  items: FulfillmentItem[] | null | undefined,
): OrderFulfillmentStatus => {
  if (!items?.length) return 'Unfulfilled';

  const progress = items.map(getItemFulfillmentProgress);

  if (progress.every((itemProgress) => itemProgress === 1)) {
    return 'Fulfilled';
  }
  if (progress.some((itemProgress) => itemProgress > 0)) {
    return 'Partially Fulfilled';
  }
  return 'Unfulfilled';
};

export const getOrderFulfillmentStatusType = (
  status: OrderFulfillmentStatus,
): 'success' | 'warning' | 'error' => {
  if (status === 'Fulfilled') return 'success';
  if (status === 'Partially Fulfilled') return 'warning';
  return 'error';
};
